<!-- TeamTreeNode.vue -->
<template>
	<div class="node">
		<div class="item_1">
			<div class="itemTop">
				
				<div class="addr">ID：#{{ node.id }} </div>
				<div class="muted"><span data-lang="t_212"></span> {{ node.people }}</div>
				
			</div>

			<div class="cols3">
				<div>
					<div class="k" data-lang="t_213"></div>
					<div class="v2" style="padding: auto 5px;">{{ node.totalMine/100 }}</div>
				</div>
				<div>
					<div class="k" data-lang="t_214"></div>
					<div class="v2">{{ node.leval > 100 ? node.leval - 100 : 0 }}</div>
				</div>
				<div>
					<button class="btn btn-mini" @click="toggleChildren">
						{{ expanded == 2 ? t_215 : t_216 }}
					</button>
				</div>
			</div>
		</div>

		<!-- 递归渲染下级 -->
		<div v-if="expanded == 2" class="children">
			<TeamTreeNode v-for="child in teamData" :key="child.id" :node="child"/>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'TeamTreeNode',
		props: {
			node: Object,
			loadChildren: Function
		},
		data() {
			return {
				expanded:0,//是否展开
				teamData:[],
				t_215:Lang[lg].t_215,
				t_216:Lang[lg].t_216
			}
		},
		mounted() {
			this.setLanguage();
		},
		methods: {
			setLanguage(){
				const elements = document.querySelectorAll('[data-lang]');
				
				elements.forEach(element => {
				    const langValue = element.getAttribute('data-lang');
					
				    element.innerHTML = Lang[lg][langValue];
				});
			},
			async toggleChildren() {
				if(this.expanded == 0){//加载数据
					//获取下级地址
					if(this.node.id == 0)return;
					let id = Number("0x" + this.node.id)
					const childId = await conMine.getChildId(id).call();
					const child = await conMine.GetBrother(childId,100).call();
					if(child == null)return;
					const len = child.length;
					let point = 2;	
					let index = 0 ;
					let team=[];
					while(point < len){
						team[index]={};
						team[index].id =Number("0x"+child.substring(point,point + 8))  ; point +=8;
						team[index].people = Number("0x"+child.substring(point,point + 8));point +=8;
						team[index].totalMine = Number("0x"+child.substring(point,point + 8));point +=8;
						team[index].leval = Number("0x"+child.substring(point,point+2));point +=2;
						team[index].quickenFloor = Number("0x"+child.substring(point,point+2));point +=2;
						team[index].children=[]; // 存储下级数据
						team[index].expanded=false; // 控制是否展开
						team[index].id = team[index].id.toString(16).toLocaleUpperCase();//转换成16进制
						index ++;
					}
					this.teamData = team;
					this.expanded = 2;
				}else if(this.expanded == 1){
					this.expanded = 2;
				}else if(this.expanded == 2){
					this.expanded = 1;
				}
				
			},
		}
	}
</script>
<style>
	.children {
	  margin-left: 5px;
	  border-left: 1px solid #6d5dfc;
	  padding-left: 10px;
	  border-radius: 15px;
	}
	
	.node {
	  margin-bottom: 10px;
	}
</style>